/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderDetailDto } from '../../models/shop-order-detail-dto';
import { ShopOrderUpdateTrackingDto } from '../../models/shop-order-update-tracking-dto';

export interface ShopOrderControllerUpdateTracking$Params {

/**
 * 주문 ID
 */
  id: string;
      body: ShopOrderUpdateTrackingDto
}

export function shopOrderControllerUpdateTracking(http: HttpClient, rootUrl: string, params: ShopOrderControllerUpdateTracking$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDetailDto>> {
  const rb = new RequestBuilder(rootUrl, shopOrderControllerUpdateTracking.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDetailDto>;
    })
  );
}

shopOrderControllerUpdateTracking.PATH = '/api/shop-orders/{id}/tracking';
